module.exports = __webpack_public_path__ + "circle_support_sm.97ce96f9.svg";